import React, { useEffect, useRef, useState } from 'react';
import { IoMdPricetag } from 'react-icons/io';
import { Container, Highlights } from './styles';

const IPVA = () => {
  const bannerRef = useRef(null);
  const [bannerConfig, setBannerConfig] = useState({
    text: '',
    link: '',
    isClickable: false,
  });

  const getYear = () => {
    const year = new Date().getFullYear();

    const targetDate = new Date(`${year}-12-13T23:59:59`);
    const currentDate = new Date();
    if (currentDate > targetDate) {
      return year + 1;
    }

    return year;
  };

  // Texto padrão como fallback
  const defaultText = `Todos os carros com IPVA ${getYear()} pago!`;

  useEffect(() => {
    // Função para obter configuração do GTM
    const getGTMConfig = () => {
      try {
        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          // Procura por configuração específica do banner IPVA no dataLayer
          const bannerConfig = window.dataLayer.find(
            item => item.event === 'BANNER_IPVA_CONFIG' || item.bannerType === 'IPVA'
          );

          if (bannerConfig) {
            return {
              text: bannerConfig.bannerText || '',
              link: bannerConfig.bannerLink || '',
              isClickable: !!bannerConfig.bannerLink,
            };
          }
        }
      } catch (error) {
        console.warn('Erro ao acessar dataLayer:', error);
      }
      return null;
    };

    // Verifica se há configuração do GTM
    const gtmConfig = getGTMConfig();

    if (gtmConfig) {
      setBannerConfig(gtmConfig);
    } else {
      // Fallback para configuração padrão SEM link
      setBannerConfig({
        text: defaultText,
        link: '',
        isClickable: false,
      });
    }

    // Listener para mudanças no dataLayer usando MutationObserver
    let observer;

    const setupDataLayerObserver = () => {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          // Salva a referência original
          const originalPush = window.dataLayer.push;

          // Sobrescreve temporariamente para detectar mudanças
          window.dataLayer.push = function(...args) {
            const result = originalPush.apply(this, args);

            // Verifica se a mudança é relevante para o banner IPVA
            const hasRelevantChange = args.some(arg => 
              arg && (arg.event === 'BANNER_IPVA_CONFIG' || arg.bannerType === 'IPVA')
            );

            if (hasRelevantChange) {
              const newConfig = getGTMConfig();
              if (newConfig) {
                setBannerConfig(newConfig);
              }
            }

            return result;
          };

          // Restaura a função original após um tempo para evitar problemas
          setTimeout(() => {
            if (window.dataLayer && window.dataLayer.push !== originalPush) {
              window.dataLayer.push = originalPush;
            }
          }, 1000);
        }
      } catch (error) {
        console.warn('Erro ao configurar observer do dataLayer:', error);
      }
    };

    // Configura o observer
    setupDataLayerObserver();

    return () => {
      // Cleanup mais seguro
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          // Não tenta restaurar aqui para evitar problemas
        }
      } catch (error) {
        console.warn('Erro no cleanup:', error);
      }
    };
  }, [defaultText]);

  const handleBannerClick = () => {
    if (!bannerConfig.isClickable || !bannerConfig.link) return;

    try {
      window.open(bannerConfig.link, '_blank');
    } catch (error) {
      console.warn('Erro ao abrir link:', error);
    }
  };

  const displayText = bannerConfig.text || defaultText;

  return (
    <Container
      bgColor={getYear() === 2024 ? '#bcf738' : '#8DFFFA'}
      id="banner-ipva"
      data-gtm-banner="ipva"
    >
      <Container.Body
        ref={bannerRef}
        onClick={handleBannerClick}
        style={{
          cursor: bannerConfig.isClickable ? 'pointer' : 'default',
          transition: 'opacity 0.2s ease',
        }}
        onMouseEnter={e => {
          if (bannerConfig.isClickable) {
            e.currentTarget.style.opacity = '0.8';
          }
        }}
        onMouseLeave={e => {
          if (bannerConfig.isClickable) {
            e.currentTarget.style.opacity = '1';
          }
        }}
      >
        <IoMdPricetag fill="#171c24" size={28} />
        <span className="text" id="banner-ipva-text">
          {displayText.includes('IPVA') ? (
            <>
              {displayText
                .split(/(IPVA\s*\d+)/)
                .map((part, index) =>
                  part.match(/IPVA\s*\d+/) ? <Highlights key={index}>{part}</Highlights> : part
                )}
            </>
          ) : (
            displayText
          )}
        </span>
      </Container.Body>
    </Container>
  );
};

export default IPVA;
